import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import { sortArrayByLabel } from "shared/util/string";
import { useTranslation } from "react-i18next";

import "./Select.css";

const CustomSelect = (props) => {
  const { t } = useTranslation();

  const [selection, setSelection] = useState(props.initialValue);

  useEffect(() => {
    if (props.initialValue) {
      handleChange(props.initialValue, "", false);
    }
    //eslint-disable-next-line
  }, []);

  //eslint-disable-next-line
  const handleChange = useCallback((selectedoption, action, dontFire = false) => {
    if (!props.isMulti) {
      setSelection(selectedoption);
      props.onInput(props.id, selectedoption.value, true);

      if (props.fireChange && !dontFire) {
        props.fireChange(selectedoption.value);
      }
    } else {
      if (selectedoption) {
        // const sortedSelections = sortArrayByLabel(selectedoption);
        setSelection(selectedoption);
        props.onInput(
          props.id,
          selectedoption.map((item) => item.value),
          true
        );
        if (props.fireChange && !dontFire) {
          props.fireChange(selectedoption.map((item) => item.value));
        }
      } else {
        props.onInput(props.id, [], false);
        setSelection([]);
      }
    }
  });

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };
  return (
    <div className="select-input">
      {props.label && <label htmlFor={props.id}>{props.label}</label>}

      <Select
        id={props.id}
        isDisabled={props.disabled}
        isSearchable={true}
        value={selection}
        isMulti={props.isMulti}
        onChange={handleChange}
        options={props.options}
        placeholder={t("select")}
        styles={selectStyles}
      />
    </div>
  );
};

export default CustomSelect;
